module.exports = __webpack_public_path__ + "static/afi1-77fbd024a97a79ae49440cf35a482e06.jpg";